export const navbarLinks = [
  {
    href: "#",
    name: "Demos",
  },
  {
    href: "#",
    name: "About",
  },
  {
    href: "#",
    name: "Blog",
  },
  {
    href: "#",
    name: "Pages",
  },
  {
    href: "#",
    name: "Contact",
  },
];
